import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=7c82bf14&"
import script from "./Mailing.vue?vue&type=script&lang=ts&"
export * from "./Mailing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports